export const DELETE_ABSENCE_TEXT = {
	title: 'Delete this absence?',
	content: "Once this absence it's deleted, it can only be recreated manually!",
	cancelButton: 'Cancel',
	confirmButton: 'Delete',
};

export const DELETE_RRO_ABSENCE_TEXT = {
	title: 'Delete this Regular Operator Time Off absence?',
	content:
		"This is a regular operator time off absence - once this absence it's deleted, it can only be recreated manually!",
	cancelButton: 'Cancel',
	confirmButton: 'Delete',
};
